module.exports = __webpack_public_path__ + "img/flag-rus.cc152198.svg";